// For icon name and codes, refer here https://github.com/google/material-design-icons/blob/master/iconfont/codepoints
var Model = Object.freeze({
  save: {
    name: 'Save',
    icon: '&#xE161',
    color: '#27C42F'
  },
  face: {
    name: 'Face',
    icon: '&#xE87C;',
    color: '#27C42F'
  }
})

export default {
  MODEL: Model
}
